export const TAB_SESSION_HEADER = "x-tab-session-id";

export const TAB_ACTIVITY_COOKIE_NAME = "_last_api_activity";
export const TAB_ACTIVITY_COOKIE_MAX_AGE_SECONDS = 60;
export const TAB_ACTIVITY_COOKIE_DELIMITER = "|";
export const TAB_ACTIVITY_COOKIE_POLL_INTERVAL_MS = 1000;
